import { helper } from '@ember/component/helper';
import { format } from 'date-fns';

export function fullMonthDate([inputDate]) {
  return format(new Date(inputDate), 'MMMM dd, yyyy');
}

export default helper(fullMonthDate);
